"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchDisplayListsQueryDto = void 0;
const cursor_pagination_1 = require("../../cursor-pagination");
class SearchDisplayListsQueryDto extends cursor_pagination_1.CursorPaginationOptions {
    createdAtFrom;
    createdAtTo;
    displayIds;
    displayListIds;
    tags;
    flatten;
    owners;
    search;
    viewPrivate;
    withDisplays;
}
exports.SearchDisplayListsQueryDto = SearchDisplayListsQueryDto;
